import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgPlanSelector } from '../../../redux/app/selectors/organization';

interface ManagementSectionProps {
  clickHandler: () => void;
  title: string;
  description: string;
  buttonName: string;
  buttonColor: string;
}

export const ManagementSection = ({
  clickHandler,
  title,
  description,
  buttonName,
  buttonColor,
}: ManagementSectionProps) => {
  const plan = useSelector(orgPlanSelector);
  const isTrialPlan = plan === 'trial-plan-4';

  return (
    <div className="body mb-10">
      <p className="fsz-16 bold-900 mb-5">{title}</p>
      <div className="content flex justify-between">
        <div className="col-left">
          <p className="fsz-13 mb-5">{description}</p>
        </div>
        <div className="col-right">
          <button
            type="button"
            className={`button ${buttonColor}`}
            onClick={clickHandler}
            disabled={isTrialPlan}
          >
            {buttonName}
          </button>
        </div>
      </div>
    </div>
  );
};
